import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { FORGOT } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'

export default function ForgotPassword() {
  let dispatch = useDispatch()
  const navigate = useNavigate()
  let user = useSelector((state) => state?.loginState.auth)
  const { handleSubmit, control } = useForm({
    defaultValues: {},
    mode: "all"
  })

  return (
    <>
      <Box
        sx={{
          width: 1, height: '100vh',
          background: '#a4abb6',
        }}>

        <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
              sx={{
                width: 1, height: '100vh',
                background: '#a4abb6',
                p: '5%',
              }}>

              <Card sx={{
                minWidth: 210,
                background: 'linear-gradient(30deg, #e3e5e6, rgb(247, 235, 210)) no-repeat',
                width: 1, mx: '10%'
              }}>
                <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
                  sx={{
                    width: 1, height: '80vh', p: '20%'
                  }}>
                  <Box>
                    <Box sx={{ textAlign: 'center', }}>
                      <Typography fontSize={16} fontWeight={800} color="#717171">Forgot Password</Typography>
                      <Typography fontSize={13} sx={{ my: 2 }} color="#717171">Welcome to widelapse monitoring system</Typography>
                    </Box>
                    <form autoComplete="false" onSubmit={handleSubmit((data) => {
                      data.reset_url = `${window.location.origin}/#/reset-password`;
                      console.log("DATA", data)
                      dispatch({ type: `${FORGOT}_POST`, payload: data });
                    })}>
                      <RFG labelStyle={{ color: "#717171" }} name="email" label="Email" control={control} rules={{ required: true }} className="mb-2">
                        <input autoComplete="false" style={{ borderRadius: 12, color: "#717171" }} />
                      </RFG>


                      <Button sx={{ width: 1, mt: 4, background: '#ffd85f', borderRadius: 2 }} type="submit">Submit</Button>
                    </form>
                    <Typography component={'a'} sx={{ mb: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}
                      onClick={() => { navigate('/') }}>Login</Typography>

                    <Box fontSize={12} className="error">{user?.message}</Box>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                      <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Powered by widelapse</Typography>
                      <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Terms & conditions</Typography>
                    </Box>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Grid>
          {/* <Grid size={{ xs: 12, sm: 12, md: 7 }} sx={{ p: '1%', display: { xs: 'none', sm: 'none', md: 'block' } }}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
              sx={{
                width: 1, height: '80vh', overflow: 'hidden', borderRadius: 3
              }}>
              <img height={'100%'} src={"https://images.pexels.com/photos/2341830/pexels-photo-2341830.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"} />
            </Box>
          </Grid> */}
        </Grid>
      </Box>
    </>
  )
}

